var _defs, _rect, _path, _path2, _circle, _path3, _path4, _path5, _ellipse, _ellipse2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeaPanel3B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 227 457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-4{fill:none;}.cls-2,.cls-5,.cls-6,.cls-7{fill:#fff;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{stroke:#000;}.cls-2,.cls-3,.cls-4{stroke-miterlimit:10;}.cls-4,.cls-5,.cls-6,.cls-7{stroke-linecap:round;}.cls-5,.cls-6,.cls-7{stroke-linejoin:round;}.cls-6{stroke-width:0.81px;}.cls-7{stroke-width:0.81px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 227,
    height: 457
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.28,268.4a15.47,15.47,0,0,0,4.88,3.48,7.14,7.14,0,0,0,5.85,0c3.43-1.77,4-6.53,3-10.25s-3.2-7.09-3.82-10.89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.5,255.71a31.91,31.91,0,0,0-.71,9.72c.43,3.24,2,6.49,4.84,8.11s7,1.1,8.7-1.66"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 95.93,
    cy: 243.51,
    r: 33.49
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.21,252.9a52.89,52.89,0,0,0,30-43.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.81,236.4a44,44,0,0,0,45.69,3.53"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.71,242.6c0,6.53.14,10.23.65,16.54"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.04,
    cy: 257.33,
    rx: 2.89,
    ry: 4.04,
    transform: "translate(-2.75 0.96) rotate(-0.61)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.26,
    cy: 257.11,
    rx: 2.89,
    ry: 4.04,
    transform: "translate(-2.75 1.17) rotate(-0.61)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M94.87,269.43a8.94,8.94,0,0,0,6.38.26"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.85,359.6l-1.38,23.85a8.61,8.61,0,0,0,10.07,9l119.87-20.89a8.61,8.61,0,0,0,4.87-14.3l-15.54-17a8.57,8.57,0,0,0-6.93-2.79A744.68,744.68,0,0,0,63.62,351.68,8.59,8.59,0,0,0,56.85,359.6Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M71.82,298.25a12.69,12.69,0,0,0-8.4,3.92,1.08,1.08,0,0,0-.41.9c.08.46.6.63,1,.71a56.37,56.37,0,0,0,10.46,1.31,18.7,18.7,0,0,0,10-2.58C80.82,299,75.61,298,71.82,298.25Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.74,302.5c0,30.44,3,40.69,14.36,55.78A44,44,0,0,0,86.55,364a9,9,0,0,0,6.75,2.17c4.24-.36,6-2.53,6-7,0-2.4-1.69-4.77-2.39-7.09l3.54,1a5.77,5.77,0,0,0,1.92.32,1.94,1.94,0,0,0,1.63-.92,1.9,1.9,0,0,0-.16-1.87,5.08,5.08,0,0,0-1.4-1.37c-2.46-1.8-6.43-3-9.29-4.07-16.08-13.08-12.48-27-12.48-44.34"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141.39,291.29a38.48,38.48,0,0,0-9.27,2.16,13,13,0,0,0-7,6.17,44.58,44.58,0,0,0,14.31-4.86,6.24,6.24,0,0,0,1.8-1.29,2.39,2.39,0,0,0,.65-2.05C141.57,291.44,141.25,291.46,141.39,291.29Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M128.86,297.72c8,23.83,7.16,31.4-.57,40.23,0,0,.09-.6,0,0a15.83,15.83,0,0,0-6.71,3.78,5.24,5.24,0,0,0-1.22,1.55,2.36,2.36,0,0,0-.08,1.91,2.47,2.47,0,0,0,2.61,1.17,9,9,0,0,0,2.82-1.15c.59-.32,1.2-.61,1.82-.88,0,.69-.08,1.38-.07,2.07.05,3.42-.61,6.71,1.61,9.31s7.51,3.38,10.7,2.15c3.63-1.4,6.62-5.48,8.67-13.69a85.05,85.05,0,0,0,2-22.55c-.58-9.75-4.44-19.07-9.57-28.59"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.78,364.82l-6.72,3.58"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M85.84,368.93c-1.58,2-3.17,4-4.75,5.95"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M149.7,357.74l5.49,5.28"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M151.43,349.76l7.13,2.67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaPanel3B);
export default __webpack_public_path__ + "static/media/Idea_Panel_3b.2dd16fde23d2fd0a0aedc3b030c694d9.svg";
export { ForwardRef as ReactComponent };